export const PROMPT_NODE_ID = 'prompt';
export const PROMPT_PLACEHOLDER = 'Describe the outcome you want...';
export const PROMPT_X = 48;
export const PROMPT_Y = 120;
export const PROMPT_W = 280;
export const PROMPT_H = 108;
export const PROMPT_GAP = 80;

export function isPromptSelected(selectedId: string | null): boolean {
  return selectedId === PROMPT_NODE_ID;
}

export function promptIsEmpty(prompt: string): boolean {
  return prompt.trim().length === 0;
}

export function promptSnippet(prompt: string, max = 72): string {
  const line = prompt.trim().split(/\n/)[0] || '';
  if (!line) return '';
  if (line.length <= max) return line;
  return `${line.slice(0, max - 1).trimEnd()}...`;
}

export function skillStartX(): number {
  return PROMPT_X + PROMPT_W + PROMPT_GAP;
}
